import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accountAuth__container"
}
const _hoisted_2 = { class: "accountAuth__para accountAuth__icon" }
const _hoisted_3 = {
  key: 1,
  class: "favorites__container"
}
const _hoisted_4 = { class: "favorites__loading" }
const _hoisted_5 = {
  key: 0,
  class: "favorites__para favorites__para--sub"
}
const _hoisted_6 = {
  key: 1,
  class: "favorites__para"
}
const _hoisted_7 = {
  key: 2,
  class: "favoritesCards"
}
const _hoisted_8 = { class: "favoritesCard" }
const _hoisted_9 = { class: "favoritesCard__image" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "favoritesCard__details" }
const _hoisted_12 = { class: "favoritesCard__company" }
const _hoisted_13 = { class: "favoritesCard__para" }
const _hoisted_14 = { class: "favoritesCard__delete" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.view === '' ? 'accountAuth' : 'accountAuth accountAuth--favorites')
  }, [
    (_ctx.view === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createVNode(_component_v_icon, {
              fill: "hsl(220, 13%, 13%)",
              name: "pr-user"
            }),
            _createTextVNode("My Account")
          ]),
          _createElementVNode("p", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeView('favorites'))),
            class: "accountAuth__para accountAuth__icon"
          }, [
            _createVNode(_component_v_icon, {
              fill: "hsl(220, 13%, 13%)",
              name: "hi-heart"
            }),
            _createTextVNode("Favorites ")
          ]),
          _createElementVNode("p", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            class: "accountAuth__para accountAuth__icon"
          }, [
            _createVNode(_component_v_icon, {
              fill: "hsl(220, 13%, 13%)",
              name: "co-account-logout"
            }),
            _createTextVNode("Log out ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.view === 'favorites')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "accountAuth__icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeView('')))
          }, [
            _createVNode(_component_v_icon, { name: "md-keyboardarrowleft-outlined" })
          ]),
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.isFetching ? 'favorites__title favorites__title--active' : 'favorites__title')
          }, "Favorites", 2),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isFetching)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  fill: "hsl(26, 100%, 55%)",
                  name: "fa-spinner",
                  scale: "2",
                  animation: "spin-pulse"
                }))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isFetching && _ctx.favorites.favorites.length < 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " You don’t have any favorites "))
            : _createCommentVNode("", true),
          (!_ctx.isFetching && _ctx.favorites.favorites.length < 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Did you know we update our collection every week? "))
            : _createCommentVNode("", true),
          (!_ctx.isFetching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites.favorites, (favorite) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: favorite.id
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: 
                favorite.id === 1
                  ? { name: 'Product', params: { id: favorite.id } }
                  : { name: 'Details', params: { id: favorite.id } }
              
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("img", {
                              src: favorite.image,
                              alt: 'image' + favorite.name
                            }, null, 8, _hoisted_10)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        to: 
                favorite.id === 1
                  ? { name: 'Product', params: { id: favorite.id } }
                  : { name: 'Details', params: { id: favorite.id } }
              
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h5", _hoisted_12, _toDisplayString(favorite.company), 1),
                            _createElementVNode("p", _hoisted_13, _toDisplayString(favorite.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "favoritesCard__deleteBtn",
                          onClick: ($event: any) => (_ctx.handleDelete(favorite))
                        }, [
                          _createVNode(_component_v_icon, {
                            name: "la-trash-alt-solid",
                            fill: "hsl(219, 9%, 45%)"
                          })
                        ], 8, _hoisted_15)
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}